import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumn } from "./common.styles";
export const FilterSheetBody = styled(FlexColumn) `
    gap: 0;
    width: 100%;
    margin-top: 8px;
`;
export const FilterSheetGroupHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 24px 0 8px;
    width: 100%;
    box-sizing: border-box;
`;
export const FilterSheetGroupLabel = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    letter-spacing: 0.24px;
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
`;
export const FilterSheetGroupDivider = styled.div `
    flex: 1;
    min-width: 0;
    height: 0;
    border-top: 0.37px solid ${colors.history_separator};
`;
export const FilterSheetPillsGroup = styled.div `
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    padding: 16px 0;
    width: 100%;
    box-sizing: border-box;
`;
